import { render, staticRenderFns } from "./create.vue?vue&type=template&id=0ab2ff8e&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=0ab2ff8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2ff8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab2ff8e')) {
      api.createRecord('0ab2ff8e', component.options)
    } else {
      api.reload('0ab2ff8e', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=0ab2ff8e&scoped=true&", function () {
      api.rerender('0ab2ff8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/create/create.vue"
export default component.exports